// Bu dosya, backend API'niz ile tüm iletişimi merkezi olarak yönetir.
// JWT Token yönetimi bu dosyaya eklenmiştir.

/**
 * Tarayıcı hafızasından (localStorage) JWT token'ını okur
 * ve API istekleri için gerekli olan Authorization başlığını oluşturur.
 * @returns {HeadersInit} - Token varsa Authorization başlığını içeren bir header objesi.
 */
const getAuthHeaders = () => {
    // Tarayıcı hafızasından token'ı oku
    const token = localStorage.getItem('userToken');
    
    const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json' // Backend'den JSON beklediğimizi belirtmek iyi bir pratiktir.
    };
    
    // Eğer token varsa, Authorization başlığına "Bearer" şemasıyla ekle
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    
    return headers;
};

const api = {
    /**
     * Kullanıcı girişi yapar ve başarılı olursa gelen token'ı tarayıcı hafızasına kaydeder.
     * @param {string} kullaniciAdi - Kullanıcının adı
     * @param {string} sifre - Kullanıcının şifresi
     * @returns {Promise<object>} - Başarılı giriş sonrası backend'den dönen veri (token ve kullanıcı bilgileri dahil).
     */
    login: async (kullaniciAdi, sifre) => {
        // Login isteğinde henüz token olmaz, bu yüzden standart başlık kullanılır.
        const response = await fetch('/api/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ kullanici_adi: kullaniciAdi, sifre: sifre })
        });
        
        if (!response.ok) {
            try {
                const errorData = await response.json();
                throw new Error(errorData.hata || 'Bilinmeyen bir hata oluştu.');
            } catch (e) {
                throw new Error('Sunucudan geçersiz yanıt alındı veya sunucuya ulaşılamıyor.');
            }
        }
        
        const data = await response.json();

        // --- EN ÖNEMLİ DEĞİŞİKLİK ---
        // Backend'den token geldiyse, bunu 'userToken' adıyla tarayıcı hafızasına (localStorage) kaydet.
        if (data.token) {
            localStorage.setItem('userToken', data.token);
        }
        // -------------------------

        return data;
    },
    
    /**
     * Korumalı bir endpoint olan tüm siparişleri listeler.
     * İstek gönderilirken token otomatik olarak eklenir.
     * @returns {Promise<Array>} - Siparişlerin listesi.
     */
    getSiparisler: async () => {
        const response = await fetch('/api/siparisler', {
            method: 'GET',
            headers: getAuthHeaders() // Kimlik doğrulamalı başlıkları kullan
        });

        if (!response.ok) {
            // Token'ın süresi dolmuş veya geçersiz olabilir.
            if (response.status === 401) {
                // Bu durumda kullanıcıyı otomatik olarak logout yapıp login sayfasına yönlendirebilirsiniz.
                // localStorage.removeItem('userToken');
                // window.location.href = '/login';
            }
            throw new Error('Siparişler getirilemedi. Lütfen tekrar giriş yapmayı deneyin.');
        }
        return await response.json();
    },

    /**
     * Korumalı bir endpoint olan tek bir siparişin detayını getirir.
     * @param {number|string} siparisId - Detayı istenen siparişin ID'si.
     * @returns {Promise<object>} - Siparişin detay verisi.
     */
    getSiparisDetayi: async (siparisId) => {
        const response = await fetch(`/api/siparisler/${siparisId}`, {
            method: 'GET',
            headers: getAuthHeaders() // Kimlik doğrulamalı başlıkları kullan
        });
        
        if (!response.ok) {
            throw new Error('Sipariş detayı getirilemedi.');
        }
        return await response.json();
    }

    // --- BURADAN SONRASI ---
    // Projenizdeki DİĞER TÜM KORUMALI API fonksiyonlarını bu mantıkla güncellemelisiniz.
    // Her `fetch` isteğinin içine `method` ve `body` (gerekliyse) ile birlikte
    // `headers: getAuthHeaders()` eklemeniz yeterlidir.
    // Örnek:
    /*
    deleteSiparis: async (siparisId) => {
        const response = await fetch(`/api/siparisler/${siparisId}`, {
            method: 'DELETE',
            headers: getAuthHeaders() // Kimlik doğrulaması burada da gerekli
        });
        
        if (!response.ok) {
            throw new Error('Sipariş silinemedi.');
        }
        return await response.json();
    }
    */
};

export default api;